export const isValidUrl = async (urlString: string) => {
  return !isValidUrlSync(urlString) ? 'Incorrect URL' : ''
}

export const isValidUrlSync = (urlString: string) => {
  const regexp = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
  return regexp.test(urlString)
}
